import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=5bbd5b41&scoped=true"
import script from "./Bookings.vue?vue&type=script&lang=js"
export * from "./Bookings.vue?vue&type=script&lang=js"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=5bbd5b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd5b41",
  null
  
)

export default component.exports